// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import { BlockWrapper, renderEmptyMessage } from '../StatisticMetricsPage'
import type { Counter } from '../StatisticMetricsPage'
import MultiSelect from '../controls/MultiSelect'
import LabeledWrapper from '../AudienceEdit/LabeledWrapper'
import type { OptionType } from '../types'
import { translations, translateFunc } from '../../shared/localize'
import Select from '../controls/Select'

type Props = {|
  allCounters: Array<Counter>,
  accountOptions: Array<OptionType>,
  selectedAccountId: string,
  counterOptions: Array<OptionType>,
  selectedCounterIds: Array<string>,
  selectedGoalIds: Array<string>,
  isLoading: boolean,
  dataType: 'goals' | 'transactions',
  onChange: Function
|}

const tFunc = translateFunc(translations.statistic_metrics_page)

const t = {
  choose_account: 'Выберите аккаунт',
  choose_data_type: 'Выберите тип данных',
  goals: 'Цели',
  transactions: 'Транзакции'
}

export default class GoogleAnalyticsBlock extends Component<Props> {
  render() {
    const {
      accountOptions,
      selectedAccountId,
      counterOptions,
      selectedCounterIds,
      selectedGoalIds,
      isLoading,
      dataType,
      onChange
    } = this.props

    if (_.isEmpty(counterOptions)) return renderEmptyMessage()

    return (
      <BlockWrapper>
        <LabeledWrapper
          className="t-AccountSelect__google_analytics"
          label={t.choose_account}
          twoLines
        >
          <Select
            placeholder={t.choose_account}
            value={selectedAccountId}
            options={accountOptions}
            onChange={(id) => onChange({ selectedGAAccountId: id })}
            disabled={isLoading}
          />
        </LabeledWrapper>
        <LabeledWrapper
          className="t-CounterSelect__google_analytics"
          label={tFunc('choose_counters')}
          twoLines
        >
          <MultiSelect
            placeholder={tFunc('choose_counters')}
            noResultsText={tFunc('no_counters_message')}
            value={selectedCounterIds}
            options={counterOptions}
            onChange={(counterIds) => onChange({ selectedGACounterIds: counterIds })}
            disabled={isLoading}
          />
        </LabeledWrapper>
        <LabeledWrapper
          className="t-DataTypeSelect__google_analytics"
          label={t.choose_data_type}
          twoLines
        >
          <Select
            value={dataType}
            options={[
              { id: 'goals', name: t.goals },
              { id: 'transactions', name: t.transactions }
            ]}
            onChange={(dataType) => {
              if (_.isEqual(dataType, 'transactions')) {
                onChange({ gaDataType: dataType, selectedGAGoalIds: [] })
              } else {
                onChange({ gaDataType: dataType })
              }
            }}
            disabled={isLoading}
          />
        </LabeledWrapper>
        {_.isEqual(dataType, 'goals') && (
          <LabeledWrapper
            className="t-GoalsSelect__google_analytics"
            label={tFunc('choose_goals')}
            twoLines
          >
            <MultiSelect
              placeholder={tFunc('goals_placeholder')}
              noResultsText={tFunc('no_goals_message')}
              value={selectedGoalIds}
              options={this.goalOptions()}
              onChange={(goalIds) => onChange({ selectedGAGoalIds: goalIds })}
              disabled={isLoading}
            />
          </LabeledWrapper>
        )}
      </BlockWrapper>
    )
  }

  goalOptions(): Array<OptionType> {
    const { allCounters, selectedCounterIds } = this.props
    const initialCounters = _.filter(allCounters, (counter) => {
      return (
        _.includes(selectedCounterIds, counter.id) &&
        _.isEqual(counter.provider, 'google_analytics')
      )
    })
    return _.flatten(
      _.map(initialCounters, (counter) => {
        return _.map(counter.goals, (goal) => {
          return { id: `${counter.id}_${goal.id}`, name: goal.name }
        })
      })
    )
  }
}
